export const PORTFOLIO_ABILITIES = {
  CAN_CREATE_TASK: "canCreateTask",
  CAN_CREATE_PUBLIC_TASK: "canCreatePublicTask",
  CAN_CREATE_TEMPLATE: "canCreateTemplate",
} as const;

export type PortfolioAbility =
  (typeof PORTFOLIO_ABILITIES)[keyof typeof PORTFOLIO_ABILITIES];
